// TABLE
export const TABLE_ROW_HEIGHT = 40;
export const TABLE_HEADER_HEIGHT = 50;

// ICON
export const STANDARD_TOOLTIP_ICON_SIZE = '20px';
